import React from 'react';
import './TempleUpdates.css';

const templeUpdates = [
  {
    id: 1,
    title: "Slotted Sarva Darshan",
    date: "Running Slot: 1 on 09-Jan-2026",
    description: "Balance tickets: 500",
    status: "Today",
  },
  {
    id: 2,
    title: "Special Entry Darshan",
    date: "₹300 per person",
    description: "Advance booking open",
    status: "Available",
  },
  {
    id: 3,
    title: "Brahmotsavam",
    date: "Annual festival",
    description: "Special seva bookings open",
    status: "15-04 Jan 2026",
  },
];

function TempleUpdates() {
  return (
    <div className="temple-updates">
      <div className="updates-header">
        <i className="fas fa-bullhorn"></i>
        <div>
          <h2 className="section-title">Temple Updates</h2>
          <p className="section-subtitle">Latest announcements</p>
        </div>
      </div>

      <div className="updates-list">
        {templeUpdates.map((update) => (
          <div className="update-card" key={update.id}>
            <div className="update-header">
              <h3>{update.title}</h3>
              <span className="update-status">{update.status}</span>
            </div>
            <p className="update-date">{update.date}</p>
            <p className="update-description">{update.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TempleUpdates;